import { useRive, useViewModelInstanceBoolean } from '@rive-app/react-canvas'
import { useEffect } from 'react'
import rivGeneral from '~/assets/rive/general.riv'
import { m } from '~/paraglide/messages'

export function PaidTrackBadge(props: {
  onClick: () => void
  isUnlocked: boolean
}) {
  const { RiveComponent, rive } = useRive({
    src: rivGeneral,
    autoplay: true,
    stateMachines: ['State Machine 1'],
    artboard: 'vip_pass_btn',
    autoBind: true,
  })

  const isUnlockedInput = useViewModelInstanceBoolean(
    'booleanProperty',
    rive?.viewModelInstance,
  )

  useEffect(() => {
    if (isUnlockedInput) {
      isUnlockedInput.setValue(props.isUnlocked)
    }
  }, [props.isUnlocked, isUnlockedInput])

  return (
    <div
      className="relative flex h-[80px] w-[100px] items-center justify-center px-[5px]"
      onClick={() => {
        if (props.isUnlocked) return
        props.onClick()
      }}
    >
      <RiveComponent className="absolute -top-3 left-1/2 h-[101px] w-[121px] -translate-x-1/2" />
      <p className="relative -top-1 text-sm font-bold text-[#054442]">
        {m.plus_reward_text()}
      </p>
    </div>
  )
}
